import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose failure is an expected state and not an error to show the user.
 *
 * The error interceptor pops a red toast for every 4xx/5xx. That is right for something the user
 * did, and wrong for a background read: the billing status call answers 404 for every workshop while
 * billing is switched off, which would flash an error on every page. A request that sets this still
 * fails normally; it just does not toast, and its caller decides what to show.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
